export default function Marquee({ items, dark = true }) {
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className={`whitespace-nowrap font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight px-6 sm:px-10 ${dark ? "text-white/12" : "text-slate-900/10"}`}>
            {item}
          </span>
          <span className={`h-1.5 w-1.5 rotate-45 ${dark ? "bg-volt/40" : "bg-volt/60"}`} />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-6 sm:py-8 select-none ${dark ? "border-white/10 bg-obsidian" : "border-slate-200 bg-white"}`}
    >
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
